module.exports = __webpack_public_path__ + "img/ss.299c834f.svg";